"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = require("../../store");
const DialogConstants_1 = require("./DialogConstants");
var SelectDialogType;
(function (SelectDialogType) {
    SelectDialogType[SelectDialogType["Select"] = 0] = "Select";
    SelectDialogType[SelectDialogType["Select2"] = 1] = "Select2";
})(SelectDialogType = exports.SelectDialogType || (exports.SelectDialogType = {}));
exports.showAlertDialog = options => {
    store_1.default.dispatch({ type: DialogConstants_1.default.ShowAlert, payload: options });
};
exports.showConfirmDialog = options => {
    store_1.default.dispatch({ type: DialogConstants_1.default.ShowConfirm, payload: options });
};
exports.showInputDialog = options => {
    store_1.default.dispatch({ type: DialogConstants_1.default.ShowInput, payload: options });
};
exports.showSelectDialog = options => {
    store_1.default.dispatch({ type: DialogConstants_1.default.ShowSelect, payload: options });
};
exports.showCustomDialog = options => {
    store_1.default.dispatch({ type: DialogConstants_1.default.ShowCustomDialog, payload: options });
};
exports.showBlockedNumbersDialog = options => {
    store_1.default.dispatch({ type: DialogConstants_1.default.ShowBlockedNumbersDialog, payload: options });
};
exports.showBlackWordDialog = options => {
    store_1.default.dispatch({ type: DialogConstants_1.default.ShowBlackWordDialog, payload: options });
};
exports.closeDialog = () => {
    store_1.default.dispatch({ type: DialogConstants_1.default.Close });
};


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/Dialog/DialogActions.ts
// module id = 605
// module chunks = 0 1 2